export enum LocalesFields {
  DateOfSignature = "DateOfSignature",
  DateOfForming = "DateOfForming",
  SelectLearningMaterials = "SelectLearningMaterials",
  Save = "Save",
  Amount = "Amount",
  Responsible = "Responsible",
  Number = "Number",
  Delete = "Delete",
  DocumentInArchive = "DocumentInArchive",
  NotSigned = "NotSigned",
  Price = "Price",
  NotSelected = "NotSelected",
  Contractor = "Contractor",
  Contract = "Contract",
  Signed = "Signed",
  Action = "Action",
  Name = "Name",
  DriveUsedTotal = "DriveUsedTotal",
  Head = "Head",
  MaximumPasswordLength = "MaximumPasswordLength",
  ShouldAPasswordContainUppercaseLatinCharacters = "ShouldAPasswordContainUppercaseLatinCharacters",
  ShouldAPasswordContainNumbers = "ShouldAPasswordContainNumbers",
  ShouldAPasswordContainLowercaseLatinCharacters = "ShouldAPasswordContainLowercaseLatinCharacters",
  MinimumPasswordLength = "MinimumPasswordLength",
  DriveTitle = "DriveTitle",
  Edit = "Edit",
  Size = "Size",
  Login = "Login",
  Company = "Company",
  User = "User",
  Formed = "Formed",
  EnterAmountRUB = "EnterAmountRUB",
  Payments = "Payments",
  AddPayment = "AddPayment",
  Actions = "Actions",
  Account = "Account",
  EnterTheSumOfPaymentRUB = "EnterTheSumOfPaymentRUB",
  Cancel = "Cancel",
  Date = "Date",
  Balance = "Balance",
  PaidIn = "PaidIn",
  EnterDirectionLearningTitle = "EnterDirectionLearningTitle",
  Description = "Description",
  EnterDescriptionOfDirectionLearning = "EnterDescriptionOfDirectionLearning",
  Apply = "Apply",
  Free = "Free",
  Used = "Used",
  Available = "Available",
  Files = "Files",
  Total = "Total",
  SettlementAccount = "SettlementAccount",
  Website = "Website",
  FullName = "FullName",
  ShortName = "ShortName",
  RussianClassificationOnObjectsOfAdministrativeDivisionOKATO = "RussianClassificationOnObjectsOfAdministrativeDivisionOKATO",
  RussianClassificationOfEconomicActivitiesOKVED = "RussianClassificationOfEconomicActivitiesOKVED",
  AddCommissionMember = "AddCommissionMember",
  Phones = "Phones",
  PatronymicName = "PatronymicName",
  CorrespondentAccount = "CorrespondentAccount",
  PositionOfHead = "PositionOfHead",
  BankIdentificationCodeBIC = "BankIdentificationCodeBIC",
  CompanyDetails = "CompanyDetails",
  TaxRegistrationReasonCodeKPP = "TaxRegistrationReasonCodeKPP",
  SelectNewHeadOfCompany = "SelectNewHeadOfCompany",
  TaxpayerIdentificationNumberTIN = "TaxpayerIdentificationNumberTIN",
  RegisteredAddress = "RegisteredAddress",
  RussianNationalClassifierOfBusinessesAndOrganizationsOKPO = "RussianNationalClassifierOfBusinessesAndOrganizationsOKPO",
  Settings = "Settings",
  Position = "Position",
  ActiveCompany = "ActiveCompany",
  Surname = "Surname",
  FullNameOfCompanysHead = "FullNameOfCompanysHead",
  TimeZone = "TimeZone",
  CommissionMembers = "CommissionMembers",
  ActualAddress = "ActualAddress",
  EnterTheName = "EnterTheName",
  Bank = "Bank",
  ActsOnTheBasisOf = "ActsOnTheBasisOf",
  FullNameOfCompanysHeadInTheGenitive = "FullNameOfCompanysHeadInTheGenitive",
  PrimaryStateRegistrationNumberPSRN = "PrimaryStateRegistrationNumberPSRN",
  HeadOfCompany = "HeadOfCompany",
  CreateCompanyEmployee = "CreateCompanyEmployee",
  EditUser = "EditUser",
  DeleteUserFromCompany = "DeleteUserFromCompany",
  Phone = "Phone",
  Commission = "Commission",
  AddEmployee = "AddEmployee",
  NotAvailable = "NotAvailable",
  UsersNotFound = "UsersNotFound",
  ImportOfUsers = "ImportOfUsers",
  Created = "Created",
  Created_male = "Created_male",
  InviteUsers = "InviteUsers",
  Warning = "Warning",
  ContactPhone = "ContactPhone",
  Role = "Role",
  Employee = "Employee",
  FirstNameSurnameOrEmailatLeastCharacters = "FirstNameSurnameOrEmailatLeastCharacters",
  SeeMore = "SeeMore",
  AddUserInCompany = "AddUserInCompany",
  Confirm = "Confirm",
  DoYouReallyWantToRemoveAUserFromYourCompany = "DoYouReallyWantToRemoveAUserFromYourCompany",
  Modified = "Modified",
  PhoneNumber = "PhoneNumber",
  Accountant = "Accountant",
  LearningRequestManager = "LearningRequestManager",
  Teacher = "Teacher",
  NumberOfUsersInTheContract = "NumberOfUsersInTheContract",
  AddFromLearningRequest = "AddFromLearningRequest",
  EnterYourPaymentOption = "EnterYourPaymentOption",
  EnterManually = "EnterManually",
  PrepaymentOf = "PrepaymentOf",
  ContractorType = "ContractorType",
  Type = "Type",
  FullPostpayment = "FullPostpayment",
  AllContracts = "AllContracts",
  LegalPerson = "LegalPerson",
  PhysicalPerson = "PhysicalPerson",
  ContractAddendum = "ContractAddendum",
  ContractAddendums = "ContractAddendums",
  EnterContractNumber = "EnterContractNumber",
  FullPrepayment = "FullPrepayment",
  PaymentTerms = "PaymentTerms",
  AddFromLearningMaterials = "AddFromLearningMaterials",
  SelectContract = "SelectContract",
  AmountRUB = "AmountRUB",
  Students = "Students",
  SourceOfPayment = "SourceOfPayment",
  PriceRUB = "PriceRUB",
  ViewAllStudents = "ViewAllStudents",
  Status = "Status",
  StartTypingALearningRequestNumber = "StartTypingALearningRequestNumber",
  LearningMaterialManager = "LearningMaterialManager",
  ResultsNotFound = "ResultsNotFound",
  LearningRequest = "LearningRequest",
  Add = "Add",
  Back = "Back",
  RecordedWebinar = "RecordedWebinar",
  Webinar = "Webinar",
  PriceForOneStudent = "PriceForOneStudent",
  EnterUsersFirstNameSurnameAndEmail = "EnterUsersFirstNameSurnameAndEmail",
  Course = "Course",
  SelectType = "SelectType",
  LearningMaterial = "LearningMaterial",
  NotSpecified = "NotSpecified",
  KaluginaLyudmilaProkofievna = "KaluginaLyudmilaProkofievna",
  CompanysFullName = "CompanysFullName",
  EgDirector = "EgDirector",
  Contacts = "Contacts",
  ShortCompanyName = "ShortCompanyName",
  OfKaluginaLyudmilaProkofievna = "OfKaluginaLyudmilaProkofievna",
  EgCompanyStatute = "EgCompanyStatute",
  StudentsCitizenshipcountryCodeOnRussianClassificationOfCountriesOfTheWorldOKSM = "StudentsCitizenshipcountryCodeOnRussianClassificationOfCountriesOfTheWorldOKSM",
  EducationalInstitutionName = "EducationalInstitutionName",
  Comment = "Comment",
  DateOfIssueOfAHESPEDocumentDateOfIssueOfAHigherEducationSecondaryProfessionalEducationDocument = "DateOfIssueOfAHESPEDocumentDateOfIssueOfAHigherEducationSecondaryProfessionalEducationDocument",
  Gender = "Gender",
  RegistrationAddress = "RegistrationAddress",
  SurnameIsStatedInADipHEDipSPESurnameIsStatedInADiplomaOfHigherEducationSecondaryProfessionalEducation = "SurnameIsStatedInADipHEDipSPESurnameIsStatedInADiplomaOfHigherEducationSecondaryProfessionalEducation",
  DateOfBirth = "DateOfBirth",
  RegistrationNumberOfAHESPEDocument = "RegistrationNumberOfAHESPEDocument",
  PassportIssuedBy = "PassportIssuedBy",
  SeriesOfAHESPEDocument = "SeriesOfAHESPEDocument",
  FromTheEducationCenter = "FromTheEducationCenter",
  PassportSeries = "PassportSeries",
  PassportNumber = "PassportNumber",
  DateOfPassportIssuance = "DateOfPassportIssuance",
  IndividualInsuranceAccountNumberSNILS = "IndividualInsuranceAccountNumberSNILS",
  HESPEDocumentNumber = "HESPEDocumentNumber",
  LevelOfEducation = "LevelOfEducation",
  UserContactPerson = "UserContactPerson",
  ContactPerson = "ContactPerson",
  ContractorResponsible = "ContractorResponsible",
  ContractorsNameOrTINatLeastCharacters = "ContractorsNameOrTINatLeastCharacters",
  Select = "Select",
  ContractorNotFound = "ContractorNotFound",
  ListOfFoundContactors = "ListOfFoundContactors",
  IfValidalityPeriodIsUnlimitedEnter = "IfValidalityPeriodIsUnlimitedEnter",
  ProfessionQualificationName = "ProfessionQualificationName",
  FISFRDOFederalInformationSystemTheFederalRegisterOfDataOnEducationDocumentsAndorAboutQualificationDocumentsOnTraining = "FISFRDOFederalInformationSystemTheFederalRegisterOfDataOnEducationDocumentsAndorAboutQualificationDocumentsOnTraining",
  FurtherEducationalProgram = "FurtherEducationalProgram",
  FinalDocument = "FinalDocument",
  DocumentsValidityPeriodMonths = "DocumentsValidityPeriodMonths",
  Published = "Published",
  Enter = "Enter",
  IntegratedGroupsOfSpecialities = "IntegratedGroupsOfSpecialities",
  LearningDirection = "LearningDirection",
  NumberOfHours = "NumberOfHours",
  RandomOrderOfLeaningCourse = "RandomOrderOfLeaningCourse",
  FieldOfProfessionalActivity = "FieldOfProfessionalActivity",
  Title = "Title",
  NotAttachedLectures = "NotAttachedLectures",
  DoYouReallyWantToDetachALectureFromThisCourse = "DoYouReallyWantToDetachALectureFromThisCourse",
  Detach = "Detach",
  Viewed = "Viewed",
  EditCourse = "EditCourse",
  Lectures = "Lectures",
  UpdateDate = "UpdateDate",
  ModifiedDate = "ModifiedDate",
  NameTeacher = "NameTeacher",
  Hours = "Hours",
  CreationDate = "CreationDate",
  NotFound = "NotFound",
  LearnerProgress = "LearnerProgress",
  RegistrationDate = "RegistrationDate",
  StartDate = "StartDate",
  UserIsntAttached = "UserIsntAttached",
  EnterFullName = "EnterFullName",
  AddStudents = "AddStudents",
  NumberOfLessons = "NumberOfLessons",
  NotStudents = "NotStudents",
  AtLeastCharacters = "AtLeastCharacters",
  IfYouRemoveAStudentFromTheCourseAllAssociatedTrainingDocumentsAreDeletedDeactivateAStudentForClosingAccess = "IfYouRemoveAStudentFromTheCourseAllAssociatedTrainingDocumentsAreDeletedDeactivateAStudentForClosingAccess",
  Clear = "Clear",
  OpenAccess = "OpenAccess",
  IfAUserIsDeactivatedAccessToTheCoursesLearningMaterialsIsClosed = "IfAUserIsDeactivatedAccessToTheCoursesLearningMaterialsIsClosed",
  RegisteredTill = "RegisteredTill",
  NotStudentsInProgress = "NotStudentsInProgress",
  RegisteredFrom = "RegisteredFrom",
  EmailFullName = "EmailFullName",
  Email = "Email",
  SelectFile = "SelectFile",
  SelectedFile = "SelectedFile",
  CopyFieldCodesInTheDocxDocumentBelowIsAnExampleOfFillingTheDocumentTemplateTokensAreHighlightedInYellowForClarityYouDontHaveToDoThat = "CopyFieldCodesInTheDocxDocumentBelowIsAnExampleOfFillingTheDocumentTemplateTokensAreHighlightedInYellowForClarityYouDontHaveToDoThat",
  TemplateType = "TemplateType",
  DocumentTemplateTitle = "DocumentTemplateTitle",
  File = "File",
  DocumentTemplateFile = "DocumentTemplateFile",
  SelectTemplate = "SelectTemplate",
  DownloadFile = "DownloadFile",
  CreateNew = "CreateNew",
  CreateNewTemplate = "CreateNewTemplate",
  Generate = "Generate",
  ActionsNotAvailable = "ActionsNotAvailable",
  TemplateTitle = "TemplateTitle",
  Tokens = "Tokens",
  RepeatedTokens = "RepeatedTokens",
  SelectEntityTemplate = "SelectEntityTemplate",
  AlwaysShowAFixedNumberOfCharacters = "AlwaysShowAFixedNumberOfCharacters",
  ForExampleUC = "ForExampleUC",
  StartingSequenceNumber = "StartingSequenceNumber",
  Prefix = "Prefix",
  Preview = "Preview",
  EnterNumberOfCharactersInANumber = "EnterNumberOfCharactersInANumber",
  Postfix = "Postfix",
  StudentsInProgress = "StudentsInProgress",
  SelectCourse = "SelectCourse",
  ReasonOfTestingKnowledge = "ReasonOfTestingKnowledge",
  ThereAreNotStudentsInTheSelectedCourseOrATrainingProtocolHasAlreadyCreated = "ThereAreNotStudentsInTheSelectedCourseOrATrainingProtocolHasAlreadyCreated",
  ThereAreNotCommissionMembersInYourCompany = "ThereAreNotCommissionMembersInYourCompany",
  Secretary = "Secretary",
  Chairman = "Chairman",
  TrainingProtocolNumber = "TrainingProtocolNumber",
  CourseResponsible = "CourseResponsible",
  Updated = "Updated",
  Practice = "Practice",
  Test = "Test",
  Training = "Training",
  AccessesToSelectedCourseOnSelectedDateHaventBeenProvided = "AccessesToSelectedCourseOnSelectedDateHaventBeenProvided",
  CompletionDate = "CompletionDate",
  OrderNumber = "OrderNumber",
  NoStudentsStartingToLearnACourse = "NoStudentsStartingToLearnACourse",
  StudentInProgress = "StudentInProgress",
  NotStudentsInProgressInTheCourse = "NotStudentsInProgressInTheCourse",
  TestIsntAttached = "TestIsntAttached",
  PracticeAssignmentIsntAttached = "PracticeAssignmentIsntAttached",
  EditContract = "EditContract",
  Order = "Order",
  DeleteCompletionOrder = "DeleteCompletionOrder",
  AvailableStudentsInProgress = "AvailableStudentsInProgress",
  AvailableStudents = "AvailableStudents",
  DocumentIsArchived = "DocumentIsArchived",
  AllDelete = "AllDelete",
  Move = "Move",
  CuttingFiles = "CuttingFiles",
  Format = "Format",
  PasteTheCopiedFilesInTheCurrentDirectory = "PasteTheCopiedFilesInTheCurrentDirectory",
  Copy = "Copy",
  DoYouReallyWantToDeleteTheseFiles = "DoYouReallyWantToDeleteTheseFiles",
  CopiedFiles = "CopiedFiles",
  FilesAreNotFoundInThisDirectory = "FilesAreNotFoundInThisDirectory",
  SearchEnterAtLeastCharacters = "SearchEnterAtLeastCharacters",
  LastFiles = "LastFiles",
  Rename = "Rename",
  EnterName = "EnterName",
  More = "More",
  CopyLinkToAFile = "CopyLinkToAFile",
  DocumentPoweredBy = "DocumentPoweredBy",
  MicrosoftOffice = "MicrosoftOffice",
  OfficeOnline = "OfficeOnline",
  ThisIsAnEmbedded = "ThisIsAnEmbedded",
  CreateFolder = "CreateFolder",
  FolderName = "FolderName",
  UploadFiles = "UploadFiles",
  DragAndDropFileHere = "DragAndDropFileHere",
  FilesNotSelected = "FilesNotSelected",
  AddFiles = "AddFiles",
  FileManager = "FileManager",
  DeleteLearningMaterial = "DeleteLearningMaterial",
  View = "View",
  FileName = "FileName",
  UploadingDate = "UploadingDate",
  AddLearningMaterial = "AddLearningMaterial",
  TheFederalBudget = "TheFederalBudget",
  ExpiryDateinMonths = "ExpiryDateinMonths",
  TrainingProtocol = "TrainingProtocol",
  EvidenceOfLoss = "EvidenceOfLoss",
  PaidEducation = "PaidEducation",
  NotInEducationalOrganization = "NotInEducationalOrganization",
  Not = "Not",
  TitleOfDiplomaThesis = "TitleOfDiplomaThesis",
  RecipientsName = "RecipientsName",
  RecipientsSurname = "RecipientsSurname",
  FulltimeparttimeStudy = "FulltimeparttimeStudy",
  ReferenceFromTheDepartmentOfInternalAffairs = "ReferenceFromTheDepartmentOfInternalAffairs",
  RegistrationNumber = "RegistrationNumber",
  Duplicate = "Duplicate",
  IssueDate = "IssueDate",
  ReferenceFromTheFireAuthorities = "ReferenceFromTheFireAuthorities",
  PlaceOfInternship = "PlaceOfInternship",
  LocalTraining = "LocalTraining",
  DuplicateSettings = "DuplicateSettings",
  FormOfReceivingEducationAtTheTimeOfTheEducationalRelationshipTermination = "FormOfReceivingEducationAtTheTimeOfTheEducationalRelationshipTermination",
  DocumentNumberForModification = "DocumentNumberForModification",
  Search = "Search",
  Other = "Other",
  FulltimeStudy = "FulltimeStudy",
  FormNumber = "FormNumber",
  FormSeries = "FormSeries",
  RegionalBudget = "RegionalBudget",
  SourceOfFunding = "SourceOfFunding",
  InEducationalOrganization = "InEducationalOrganization",
  ParttimeStudy = "ParttimeStudy",
  AwardedQualificationLevelClassCategory = "AwardedQualificationLevelClassCategory",
  FormEducation = "FormEducation",
  EvidenceOfDestroyingDocuments = "EvidenceOfDestroyingDocuments",
  SelectTrainingProtocol = "SelectTrainingProtocol",
  Original = "Original",
  ExchangeDueToFalseInformationProviding = "ExchangeDueToFalseInformationProviding",
  RecipientsPatronymic = "RecipientsPatronymic",
  ExchangeDueToDamage = "ExchangeDueToDamage",
  AnnouncementInTheNewspaper = "AnnouncementInTheNewspaper",
  ExchangeConfirmation = "ExchangeConfirmation",
  EnterIfADocumentsDurationPeriodIsUnlimited = "EnterIfADocumentsDurationPeriodIsUnlimited",
  EducationDocumentName = "EducationDocumentName",
  ValidTill = "ValidTill",
  Issued = "Issued",
  Student = "Student",
  DownloadFISFRDOFederalInformationSystemTheFederalRegisterOfDataOnEducationDocumentsAndorAboutQualificationDocumentsOnTraining = "DownloadFISFRDOFederalInformationSystemTheFederalRegisterOfDataOnEducationDocumentsAndorAboutQualificationDocumentsOnTraining",
  NotResults = "NotResults",
  InArchive = "InArchive",
  ResultsOnTheEnteredDataNotFound = "ResultsOnTheEnteredDataNotFound",
  ThisActionCannotBeUndoneAreYouSureYouWantToDelete = "ThisActionCannotBeUndoneAreYouSureYouWantToDelete",
  MoveInArchive = "MoveInArchive",
  EnterMaskName = "EnterMaskName",
  SelectNumbering = "SelectNumbering",
  SorryResultsNotFound = "SorryResultsNotFound",
  SumUpTheResults = "SumUpTheResults",
  FailedTest = "FailedTest",
  Check = "Check",
  ViewMistakes = "ViewMistakes",
  CheckingAssignments = "CheckingAssignments",
  PracticeAssignments = "PracticeAssignments",
  Courses = "Courses",
  TrainedStudentsForMonth = "TrainedStudentsForMonth",
  LearningRequests = "LearningRequests",
  Managers = "Managers",
  CourseRating = "CourseRating",
  OverviewOn = "OverviewOn",
  SalesForMonthPcs = "SalesForMonthPcs",
  RevenueRUB = "RevenueRUB",
  FinancialReport = "FinancialReport",
  TeacherAccount = "TeacherAccount",
  Learn = "Learn",
  NotLearningMaterials = "NotLearningMaterials",
  Webinars = "Webinars",
  NumberOfLectures = "NumberOfLectures",
  FinalTest = "FinalTest",
  DateAndTime = "DateAndTime",
  Participants = "Participants",
  CompletedLearningRequests = "CompletedLearningRequests",
  AmountOnTheSignedCertificatesOfCompletedWorks = "AmountOnTheSignedCertificatesOfCompletedWorks",
  Billed = "Billed",
  CertificatesOfCompletedWorks = "CertificatesOfCompletedWorks",
  Income = "Income",
  BillsRUB = "BillsRUB",
  Bills = "Bills",
  AmountOnTheIssuedCertificatesOfCompletedWorks = "AmountOnTheIssuedCertificatesOfCompletedWorks",
  Paid = "Paid",
  Debt = "Debt",
  ForSignature = "ForSignature",
  CertificatesOfCompletedWorksRUB = "CertificatesOfCompletedWorksRUB",
  GoToPayments = "GoToPayments",
  ForYesterday = "ForYesterday",
  InProcessing = "InProcessing",
  Done = "Done",
  WaitingForPrepayment = "WaitingForPrepayment",
  TrainingCompleted = "TrainingCompleted",
  GoToLearningRequests = "GoToLearningRequests",
  DocumentsPrepared = "DocumentsPrepared",
  NotProcessed = "NotProcessed",
  Contractors = "Contractors",
  LearningRequestIsFormedFrom = "LearningRequestIsFormedFrom",
  LearningRequestIsFormedTill = "LearningRequestIsFormedTill",
  RecordedWebinars = "RecordedWebinars",
  Unpublished = "Unpublished",
  ViewConductedWebinars = "ViewConductedWebinars",
  WebinarSchedule = "WebinarSchedule",
  NotUpcomingWebinar = "NotUpcomingWebinar",
  Upgrades = "Upgrades",
  AllowedDomains = "AllowedDomains",
  NameDescription = "NameDescription",
  AccessRights = "AccessRights",
  YouDontHaveTheGeneratedKeys = "YouDontHaveTheGeneratedKeys",
  PermittedIP = "PermittedIP",
  DeleteKey = "DeleteKey",
  PermittedAPI = "PermittedAPI",
  WidgetIsCreated = "WidgetIsCreated",
  WebsiteAddress = "WebsiteAddress",
  ShowDescription = "ShowDescription",
  EnterAColorInHEXFormat = "EnterAColorInHEXFormat",
  ColorOfTheTypesOfLearningMaterials = "ColorOfTheTypesOfLearningMaterials",
  WidgetContent = "WidgetContent",
  CommentToWebform = "CommentToWebform",
  ShowToplevelTitles = "ShowToplevelTitles",
  NotificationAfterSuccessfulLearningRequestSending = "NotificationAfterSuccessfulLearningRequestSending",
  SelectALearningRequestManager = "SelectALearningRequestManager",
  BackgroundColor = "BackgroundColor",
  YouAreAbleToCopyTheCodeOnlyNow = "YouAreAbleToCopyTheCodeOnlyNow",
  ThisManagerWillBeResponsibleOnTheLearningRequest = "ThisManagerWillBeResponsibleOnTheLearningRequest",
  PasteTheCodeBelowIntoTheContainerOnYourWebsiteWhereYouWantToShowAListOfLearningMaterials = "PasteTheCodeBelowIntoTheContainerOnYourWebsiteWhereYouWantToShowAListOfLearningMaterials",
  CopyWidgetCode = "CopyWidgetCode",
  MainButtonsColor = "MainButtonsColor",
  ColorOfAFontOfDirection = "ColorOfAFontOfDirection",
  ShowNumberOfHours = "ShowNumberOfHours",
  ColorOfCoursesNamePriceHours = "ColorOfCoursesNamePriceHours",
  ShowPrice = "ShowPrice",
  Manager = "Manager",
  SelectTheLearningMaterialsForAddingToTheWebsiteSeveralWidgetsCanBeAddedOnTheDifferentPagesOfOneWebsite = "SelectTheLearningMaterialsForAddingToTheWebsiteSeveralWidgetsCanBeAddedOnTheDifferentPagesOfOneWebsite",
  ExampleGooglecom = "ExampleGooglecom",
  EnterHEXColor = "EnterHEXColor",
  DeleteWidget = "DeleteWidget",
  EditWidget = "EditWidget",
  SelectUsers = "SelectUsers",
  SendInvitations = "SendInvitations",
  Useremail = "Useremail",
  MaximumScore = "MaximumScore",
  StartedCompleted = "StartedCompleted",
  Result = "Result",
  Duration = "Duration",
  TestResult = "TestResult",
  SessionIsActive = "SessionIsActive",
  TestSessionTime = "TestSessionTime",
  SessionFrom = "SessionFrom",
  Scored = "Scored",
  Opened = "Opened",
  Completed = "Completed",
  LecturesTest = "LecturesTest",
  FormedFrom = "FormedFrom",
  FormedTill = "FormedTill",
  NumberLearningRequest = "NumberLearningRequest",
  EnterNumber = "EnterNumber",
  RUB = "RUB",
  LearningRequestProfile = "LearningRequestProfile",
  DeleteFromList = "DeleteFromList",
  EnterNumberOfLearningRequest = "EnterNumberOfLearningRequest",
  NumberOfStudentsLearningACourseNumberOfStudentsInProgress = "NumberOfStudentsLearningACourseNumberOfStudentsInProgress",
  ViewListOfTheStudents = "ViewListOfTheStudents",
  ViewListOfTheStudentsLearningACourseViewListOfStudentsInProgress = "ViewListOfTheStudentsLearningACourseViewListOfStudentsInProgress",
  NumberOfStudents = "NumberOfStudents",
  AddingStudents = "AddingStudents",
  Events = "Events",
  SelectAStatusOfTheLearningRequest = "SelectAStatusOfTheLearningRequest",
  TheFollowingStatuses = "TheFollowingStatuses",
  SelectAll = "SelectAll",
  Attach = "Attach",
  ListOfAddedCourses = "ListOfAddedCourses",
  ListOfAvailableCourses = "ListOfAvailableCourses",
  SearchForAvailableCourses = "SearchForAvailableCourses",
  CourseNameatLeastCharacters = "CourseNameatLeastCharacters",
  EditCourseMaterial = "EditCourseMaterial",
  CreateCourseMaterial = "CreateCourseMaterial",
  AdditionalLearningMaterials = "AdditionalLearningMaterials",
  LectureText = "LectureText",
  Slides = "Slides",
  Video = "Video",
  Text = "Text",
  PublicationSetting = "PublicationSetting",
  LectureSlides = "LectureSlides",
  LecturePages = "LecturePages",
  EditLecture = "EditLecture",
  All = "All",
  NotLectures = "NotLectures",
  EditPage = "EditPage",
  CreateLecturePage = "CreateLecturePage",
  LearningMaterials = "LearningMaterials",
  AdditionOfLearningMaterials = "AdditionOfLearningMaterials",
  Sales = "Sales",
  ControlPanel = "ControlPanel",
  Reports = "Reports",
  Logout = "Logout",
  LearningResults = "LearningResults",
  EducationalDocuments = "EducationalDocuments",
  Assessment = "Assessment",
  NotUsers = "NotUsers",
  EmailOrFullName = "EmailOrFullName",
  NotStarted = "NotStarted",
  NotStarted_male = "NotStarted_male",
  CompleteTraining = "CompleteTraining",
  PhoneNumberIsNotSpecified = "PhoneNumberIsNotSpecified",
  AvailableOnlyForCourses = "AvailableOnlyForCourses",
  LearningRequestType = "LearningRequestType",
  AddStudentInProgress = "AddStudentInProgress",
  RegisterUser = "RegisterUser",
  Register = "Register",
  SelectWebinar = "SelectWebinar",
  Registration = "Registration",
  SelectLearningMaterialType = "SelectLearningMaterialType",
  SelectRecordedWebinar = "SelectRecordedWebinar",
  Users = "Users",
  ListOfUsersInLearningRequest = "ListOfUsersInLearningRequest",
  AttachedFiles = "AttachedFiles",
  WriteYourAnswer = "WriteYourAnswer",
  Submit = "Submit",
  AddFile = "AddFile",
  CoursePracticeAssignment = "CoursePracticeAssignment",
  Unknown = "Unknown",
  Failed = "Failed",
  Assignment = "Assignment",
  DeletedUser = "DeletedUser",
  Passed = "Passed",
  TeachersComment = "TeachersComment",
  AnswerIsSubmitted = "AnswerIsSubmitted",
  Answer = "Answer",
  UsersAnswer = "UsersAnswer",
  Attached = "Attached",
  AssignmentsConditions = "AssignmentsConditions",
  YouNeedToAddADirectLinkURLToAVideoShortLinksCouldntBeUsed = "YouNeedToAddADirectLinkURLToAVideoShortLinksCouldntBeUsed",
  AddALinkToTheSourceOrSelectAFileFromTheList = "AddALinkToTheSourceOrSelectAFileFromTheList",
  Content = "Content",
  ShowFiles = "ShowFiles",
  EditRecordedWebinar = "EditRecordedWebinar",
  MainInformation = "MainInformation",
  Documents = "Documents",
  Education = "Education",
  DeleteStudent = "DeleteStudent",
  DateOfStudentsRegistration = "DateOfStudentsRegistration",
  Upgrade = "Upgrade",
  Create = "Create",
  SelectTermType = "SelectTermType",
  SelectTest = "SelectTest",
  AttachPracticeAssignment = "AttachPracticeAssignment",
  AttachTest = "AttachTest",
  CourseDoesntIncludeAPracticeAssignment = "CourseDoesntIncludeAPracticeAssignment",
  DontAttachAPracticeAssignment = "DontAttachAPracticeAssignment",
  AddQuestionsInNewTest = "AddQuestionsInNewTest",
  Questions = "Questions",
  NumberOfQuestionsInTest = "NumberOfQuestionsInTest",
  NumberOfAttemptsToPassTestPerDay = "NumberOfAttemptsToPassTestPerDay",
  SetToShowAllQuestions = "SetToShowAllQuestions",
  MinNumberOfCorrectAnswersToPassTest = "MinNumberOfCorrectAnswersToPassTest",
  Active = "Active",
  EnterForNoTimeLimits = "EnterForNoTimeLimits",
  EditingAndPublishing = "EditingAndPublishing",
  CommentsToAnswers = "CommentsToAnswers",
  DisplayQuestionsRandomly = "DisplayQuestionsRandomly",
  TestSessionTimeinMinutes = "TestSessionTimeinMinutes",
  SetForNoTimeLimits = "SetForNoTimeLimits",
  ShowAnswerComments = "ShowAnswerComments",
  PracticeTest = "PracticeTest",
  RandomOrderOfQuestions = "RandomOrderOfQuestions",
  NumberOfAttemptsToPassTestInTotal = "NumberOfAttemptsToPassTestInTotal",
  AnswersReceived = "AnswersReceived",
  Started = "Started",
  Started_male = "Started_male",
  Correct = "Correct",
  QuestionNumber = "QuestionNumber",
  Incorrect = "Incorrect",
  Print = "Print",
  TestResults = "TestResults",
  Next = "Next",
  Question = "Question",
  StartTest = "StartTest",
  EachAnswerShouldBeStartedOnANewLineAndWithOneAsterisk = "EachAnswerShouldBeStartedOnANewLineAndWithOneAsterisk",
  ToCommentOnTheAnswersAddTheSymbolOnALineEndOfAnswer = "ToCommentOnTheAnswersAddTheSymbolOnALineEndOfAnswer",
  MarkEachNewQuestionWithThreeAsterisks = "MarkEachNewQuestionWithThreeAsterisks",
  ToAddANewParagraphToTheQuestionGoToANewLine = "ToAddANewParagraphToTheQuestionGoToANewLine",
  CheckCorrectnessOfTheGeneratedQuestionsBeforeAdding = "CheckCorrectnessOfTheGeneratedQuestionsBeforeAdding",
  ToIdentifyTheCorrectAnswersAddAnAsteriskWithAPlus = "ToIdentifyTheCorrectAnswersAddAnAsteriskWithAPlus",
  EditOrChangeExamplesOfQuestions = "EditOrChangeExamplesOfQuestions",
  Requirements = "Requirements",
  SaveQuestions = "SaveQuestions",
  CommentToAnswer = "CommentToAnswer",
  Answers = "Answers",
  SaveQuestion = "SaveQuestion",
  AddAnswer = "AddAnswer",
  EnterAnswer = "EnterAnswer",
  AddNewQuestion = "AddNewQuestion",
  BulkAdd = "BulkAdd",
  AddCopied = "AddCopied",
  Sort = "Sort",
  ShowComments = "ShowComments",
  Sorting = "Sorting",
  RequiredMinCorrectAnswersToPassTest = "RequiredMinCorrectAnswersToPassTest",
  TotalAttempts = "TotalAttempts",
  QuestionsInTest = "QuestionsInTest",
  AttemptsPerDay = "AttemptsPerDay",
  CopyAllQuestions = "CopyAllQuestions",
  TestTitle = "TestTitle",
  CopyALoginAccess = "CopyALoginAccess",
  Password = "Password",
  EducationalProgram = "EducationalProgram",
  EducationalProgramAndDocuments = "EducationalProgramAndDocuments",
  Companies = "Companies",
  Document = "Document",
  PostalAddress = "PostalAddress",
  CompanyName = "CompanyName",
  AboutMe = "AboutMe",
  ListOfFoundUsers = "ListOfFoundUsers",
  ListOfFoundStudents = "ListOfFoundStudents",
  FirstNameSurnameEmail = "FirstNameSurnameEmail",
  SelectPhoto = "SelectPhoto",
  ChangeAvailableSpace = "ChangeAvailableSpace",
  PatronymicInDativeCase = "PatronymicInDativeCase",
  Male = "Male",
  ChangePassword = "ChangePassword",
  ActiveUser = "ActiveUser",
  EnterNewPasswordAgain = "EnterNewPasswordAgain",
  SurnameInDativeCase = "SurnameInDativeCase",
  ResetPassword = "ResetPassword",
  MainData = "MainData",
  EnterOldPassword = "EnterOldPassword",
  TypeIfYouWantToChangePassword = "TypeIfYouWantToChangePassword",
  Female = "Female",
  FirstNameInDativeCase = "FirstNameInDativeCase",
  Photo = "Photo",
  EnterNewPassword = "EnterNewPassword",
  NotSelectedGender = "NotSelectedGender",
  AccessForCompany = "AccessForCompany",
  EditCompanysUser = "EditCompanysUser",
  EditCertificateOfCompletedWorks = "EditCertificateOfCompletedWorks",
  Editing = "Editing",
  PriceFrom = "PriceFrom",
  FormingDateFrom = "FormingDateFrom",
  EnterPrice = "EnterPrice",
  SignedFrom = "SignedFrom",
  CertificatesOfCompletedWorksNotFound = "CertificatesOfCompletedWorksNotFound",
  SearchForNumber = "SearchForNumber",
  FormationDateTill = "FormationDateTill",
  PriceTill = "PriceTill",
  SignedTill = "SignedTill",
  Template = "Template",
  CertificateOfCompletedWorks = "CertificateOfCompletedWorks",
  ContractorphysicalPerson = "ContractorphysicalPerson",
  CompanysName = "CompanysName",
  Profiles = "Profiles",
  SearchForName = "SearchForName",
  CreateDirectionOfLearning = "CreateDirectionOfLearning",
  DirectionsOfLearningList = "DirectionsOfLearningList",
  DirectionsOfLearning = "DirectionsOfLearning",
  NewLearningDirection = "NewLearningDirection",
  CreateCompany = "CreateCompany",
  SelectPreset = "SelectPreset",
  CreateUser = "CreateUser",
  SharingPersonalData = "SharingPersonalData",
  TheMinimumNecessaryDataProvidedByTheUsersForCommunicationNamepossiblyUseAFictitiousNameMobileNumberAndorEmailAddress = "TheMinimumNecessaryDataProvidedByTheUsersForCommunicationNamepossiblyUseAFictitiousNameMobileNumberAndorEmailAddress",
  TheUsersPersonalDataIsCollectedOnTheWebsiteByEnteringDataByTheUserOnHisOwnInitiativeAtTheTimeOfAppealingToTheWebsiteAdministrationOrTheWebsiteAccordingToTheUsersSettings = "TheUsersPersonalDataIsCollectedOnTheWebsiteByEnteringDataByTheUserOnHisOwnInitiativeAtTheTimeOfAppealingToTheWebsiteAdministrationOrTheWebsiteAccordingToTheUsersSettings",
  ComplianceOfThePurposesOfPersonalDataProcessingWithThePurposesDefinedInAdvanceAndDeclaredUnderTheCollectionOfPersonalDataAndAlsoWithTheAuthorityOfTheWebsiteAdministration = "ComplianceOfThePurposesOfPersonalDataProcessingWithThePurposesDefinedInAdvanceAndDeclaredUnderTheCollectionOfPersonalDataAndAlsoWithTheAuthorityOfTheWebsiteAdministration",
  TheAdministrationWebsiteTakesTechnicalOrganizationalAndLegalMeasuresToEnsureTheProtectionOfTheUsersPersonalDataFromUnauthorizedOrAccidentalAccessToThatDestructionModificationBlockingCopyingDisseminationAndAlsoFromOtherIllegalActions = "TheAdministrationWebsiteTakesTechnicalOrganizationalAndLegalMeasuresToEnsureTheProtectionOfTheUsersPersonalDataFromUnauthorizedOrAccidentalAccessToThatDestructionModificationBlockingCopyingDisseminationAndAlsoFromOtherIllegalActions",
  LimitationOfTheRules = "LimitationOfTheRules",
  OtherInformationAboutTheUsersProcessingByTheWebsiteAdministration = "OtherInformationAboutTheUsersProcessingByTheWebsiteAdministration",
  GeneralRegulations = "GeneralRegulations",
  TheAdministrationWebsiteDoesntTakeResponsibilityForTheActionsOfThirdPartiesWhoHaveGainedAccessToInformationAboutTheUserThroughUsingTheInternetAndWebsiteServicesAndForConsequencesOfUsageInformationThatIsInherentlyAvailableForAnyInternetUser = "TheAdministrationWebsiteDoesntTakeResponsibilityForTheActionsOfThirdPartiesWhoHaveGainedAccessToInformationAboutTheUserThroughUsingTheInternetAndWebsiteServicesAndForConsequencesOfUsageInformationThatIsInherentlyAvailableForAnyInternetUser",
  TheRelationsConnectedToProcessingCollectionStorageDisseminationAndProtectionOfTheWebsiteUsersAreRegulatedByThisRegulationOtherOfficialDocumentsOfTheWebsiteAdministrationAndTheCurrentLegislationOfTheRussianFederation = "TheRelationsConnectedToProcessingCollectionStorageDisseminationAndProtectionOfTheWebsiteUsersAreRegulatedByThisRegulationOtherOfficialDocumentsOfTheWebsiteAdministrationAndTheCurrentLegislationOfTheRussianFederation",
  TheContentOfPersonalData = "TheContentOfPersonalData",
  SharingUsersPersonalDataWithStateBodieslocalSelfgovernmentBodiesIsCarriedOutInAccordanceWithTheProcedureProvidedForByLaw = "SharingUsersPersonalDataWithStateBodieslocalSelfgovernmentBodiesIsCarriedOutInAccordanceWithTheProcedureProvidedForByLaw",
  ProcessingInformationAboutUsers = "ProcessingInformationAboutUsers",
  LawfulnessOfThePurposesAndTypesOfPersonalDataProcessing = "LawfulnessOfThePurposesAndTypesOfPersonalDataProcessing",
  ReceivedInformationAsAResultOfTheUsersActionsOnTheWebsite = "ReceivedInformationAsAResultOfTheUsersActionsOnTheWebsite",
  PurposesOfProcessingInformation = "PurposesOfProcessingInformation",
  InformationAutomaticallyReceivedWhenAccessingTheWebsiteUsingBookmarkscookies = "InformationAutomaticallyReceivedWhenAccessingTheWebsiteUsingBookmarkscookies",
  DestructionOfUsersPersonalDataIsDestroyedAtTheWrittenRequestOfTheUserTheRequestMustContainIdentificationDataThatDirectlyIndicatesThatTheInformationBelongsToThisUser = "DestructionOfUsersPersonalDataIsDestroyedAtTheWrittenRequestOfTheUserTheRequestMustContainIdentificationDataThatDirectlyIndicatesThatTheInformationBelongsToThisUser",
  ConditionsAndPurposesOfProcessingPersonalData = "ConditionsAndPurposesOfProcessingPersonalData",
  DestructionOfPersonalData = "DestructionOfPersonalData",
  TheUserAgreesToTheTermsAndConditionsOfTheRegulationByRegisteringSendingMessagesApplicationsLeadsOtherMessagesUsingTheWebFormsAndWebsiteContactMeansUsingWebsiteAndItsServicesMustBeImmediatelyTerminatedIfTheUserDoesntAgreeWithTheTermsAndConditionsOfTheRegulationsTheUserHimselfherselfIsResponsibleForThis = "TheUserAgreesToTheTermsAndConditionsOfTheRegulationByRegisteringSendingMessagesApplicationsLeadsOtherMessagesUsingTheWebFormsAndWebsiteContactMeansUsingWebsiteAndItsServicesMustBeImmediatelyTerminatedIfTheUserDoesntAgreeWithTheTermsAndConditionsOfTheRegulationsTheUserHimselfherselfIsResponsibleForThis",
  PersonalDataIsNotSharedWithAnyPersonsExceptInTheCasesSpecifiedByThisRegulation = "PersonalDataIsNotSharedWithAnyPersonsExceptInTheCasesSpecifiedByThisRegulation",
  StorageAndUsingOfPersonalData = "StorageAndUsingOfPersonalData",
  PersonalDataProcessingIsCarriedOutOnTheBasisOfTheFollowingPrinciples = "PersonalDataProcessingIsCarriedOutOnTheBasisOfTheFollowingPrinciples",
  TheProcedureOfImplementationAndChangingOfTheRegulation = "TheProcedureOfImplementationAndChangingOfTheRegulation",
  TheAdministrationWebsiteRecommendsToTheUsersTakeResponsibilityForSolutionToQuestionRegardingTheAmountOfInformationAboutThemselvesSharingFromTheWebsite = "TheAdministrationWebsiteRecommendsToTheUsersTakeResponsibilityForSolutionToQuestionRegardingTheAmountOfInformationAboutThemselvesSharingFromTheWebsite",
  TheWebsiteAdministrationProcessesInformationAboutTheUsersIncludingTheirPersonalDataForCompletionObligationsBetweenTheWebsiteAdministrationAndTheUsersWithinAProvidingInformationAboutActivityAndWorkOfStructuralSubdivisionsOfTheWebsiteOwners = "TheWebsiteAdministrationProcessesInformationAboutTheUsersIncludingTheirPersonalDataForCompletionObligationsBetweenTheWebsiteAdministrationAndTheUsersWithinAProvidingInformationAboutActivityAndWorkOfStructuralSubdivisionsOfTheWebsiteOwners",
  InformationNecessaryForIdentificationOfTheUserForAccessToWebsiteServices = "InformationNecessaryForIdentificationOfTheUserForAccessToWebsiteServices",
  TheWebsiteAdministrationDoesntVerifyTheValidityOfReceivedcollectedInformationAboutTheUsersExceptingWhenTheAdministrationWebsiteHasToCompleteObligationsToTheUser = "TheWebsiteAdministrationDoesntVerifyTheValidityOfReceivedcollectedInformationAboutTheUsersExceptingWhenTheAdministrationWebsiteHasToCompleteObligationsToTheUser",
  ApplicationsUsedByTheUsersOnTheWebsiteAreHostedAndMaintainedByThirdPartiesdevelopersWhoActIndependentlyOfTheWebsiteAdministrationAndDontActOnBehalfOrOnTheAuthorityOfTheWebsiteAdministrationTheUsersMustGetInformedThemselvesAboutTheRulesOfServiceDeliveryAndThePersonalDataProtectionPolicyOfSuchThirdPartiesdevelopersBeforeUsingTheRelevantApplications = "ApplicationsUsedByTheUsersOnTheWebsiteAreHostedAndMaintainedByThirdPartiesdevelopersWhoActIndependentlyOfTheWebsiteAdministrationAndDontActOnBehalfOrOnTheAuthorityOfTheWebsiteAdministrationTheUsersMustGetInformedThemselvesAboutTheRulesOfServiceDeliveryAndThePersonalDataProtectionPolicyOfSuchThirdPartiesdevelopersBeforeUsingTheRelevantApplications",
  PersonalDataProcessingByTheWebsiteAdministrationIsCarriedOutForCompletionObligationsBetweenTheWebsiteAdministrationAndTheUsersWithinAProvidingInformationAboutActivityAndWorkOfStructuralSubdivisionsOfTheWebsiteOwnersInAccordanceWithArticleOfFederalLawOfJulyFLAboutPersonalDataTheSeparateUsersConsentToTheProcessingOfThePersonalDataIsNotRequiredAccordingToASubparagraphClauseArticleOfThisLawTheWebsiteAdministrationHasTheRightForProcessingPersonalDataWithoutANotificationOfTheAuthorizedBodyOnTheProtectionOfTheRightsOfSubjectsOfPersonalData = "PersonalDataProcessingByTheWebsiteAdministrationIsCarriedOutForCompletionObligationsBetweenTheWebsiteAdministrationAndTheUsersWithinAProvidingInformationAboutActivityAndWorkOfStructuralSubdivisionsOfTheWebsiteOwnersInAccordanceWithArticleOfFederalLawOfJulyFLAboutPersonalDataTheSeparateUsersConsentToTheProcessingOfThePersonalDataIsNotRequiredAccordingToASubparagraphClauseArticleOfThisLawTheWebsiteAdministrationHasTheRightForProcessingPersonalDataWithoutANotificationOfTheAuthorizedBodyOnTheProtectionOfTheRightsOfSubjectsOfPersonalData",
  TheWebsiteAdministrationHasTheRightToMakeChangesToTheRegulationTheWebsiteAdministrationNotifiesTheUsersAboutTheRegulationsChangesByPostingTheNewVersionOnWebsiteAtThePermanentAddressInThisCaseThePreviousVersionsOfTheRegulationBecomeInvalid = "TheWebsiteAdministrationHasTheRightToMakeChangesToTheRegulationTheWebsiteAdministrationNotifiesTheUsersAboutTheRegulationsChangesByPostingTheNewVersionOnWebsiteAtThePermanentAddressInThisCaseThePreviousVersionsOfTheRegulationBecomeInvalid",
  TheUserAdditionallyOnHisOwnInitiativeProvidesOtherPersonalDataByUsingTheRelevantSectionsAndResourcesOfTheWebsite = "TheUserAdditionallyOnHisOwnInitiativeProvidesOtherPersonalDataByUsingTheRelevantSectionsAndResourcesOfTheWebsite",
  PersonalDataIsProvidedByTheUserVoluntarilyThatMeansAConsentToProcessingByTheWebsiteAdministrationAndIncludes = "PersonalDataIsProvidedByTheUserVoluntarilyThatMeansAConsentToProcessingByTheWebsiteAdministrationAndIncludes",
  InAdditionTheWebsiteAdministrationProcessesOtherInformationAboutTheUsersThatIncludes = "InAdditionTheWebsiteAdministrationProcessesOtherInformationAboutTheUsersThatIncludes",
  TheseRulesDoNotApplyToAThirdPartysActionsAndInternetResources = "TheseRulesDoNotApplyToAThirdPartysActionsAndInternetResources",
  ThisRegulationIsAnOfficialDocumentOfWebsiteAdministrationPostedOnThisWebsiteAndDefinesTheProcedureForTheProcessingAndProtectionOfPersonalDataOfTheWebsiteUsershereinafterTheUsersAndWebsiteServiceshereinafterTheWebsite = "ThisRegulationIsAnOfficialDocumentOfWebsiteAdministrationPostedOnThisWebsiteAndDefinesTheProcedureForTheProcessingAndProtectionOfPersonalDataOfTheWebsiteUsershereinafterTheUsersAndWebsiteServiceshereinafterTheWebsite",
  ComplianceWithTheAmountAndCharacterOfProcessedPersonalDataTypesOfPersonalDataProcessingWithThePurposesOfPersonalDataProcessing = "ComplianceWithTheAmountAndCharacterOfProcessedPersonalDataTypesOfPersonalDataProcessingWithThePurposesOfPersonalDataProcessing",
  Integrity = "Integrity",
  ThisRegulationComesIntoForceFromPostingOnWebsiteAndRemainInForceWithoutLimitOfTimeUntilReplacingItWithANewRegulation = "ThisRegulationComesIntoForceFromPostingOnWebsiteAndRemainInForceWithoutLimitOfTimeUntilReplacingItWithANewRegulation",
  MeasuresToProtectUserInformation = "MeasuresToProtectUserInformation",
  OtherDataincludingGenderAgeDateOfBirthAddressEtcIsProvidedByTheUserAtWillAndIfNecessarySuchDataForCommunicationWithTheUserAndActivitiesRelatedToDeliveryOfServiceOrProductsToTheUser = "OtherDataincludingGenderAgeDateOfBirthAddressEtcIsProvidedByTheUserAtWillAndIfNecessarySuchDataForCommunicationWithTheUserAndActivitiesRelatedToDeliveryOfServiceOrProductsToTheUser",
  CollectionOfPersonalData = "CollectionOfPersonalData",
  PurposesOfProcessingPersonalDataIncludeReceivingInformationMailingsDocumentsAndMaterialsIncludingAdvertisingByTheUserProcessingUsersOrdersWhichAreIntendedToReceiveGoodsAndServicesUserConsultingSupport = "PurposesOfProcessingPersonalDataIncludeReceivingInformationMailingsDocumentsAndMaterialsIncludingAdvertisingByTheUserProcessingUsersOrdersWhichAreIntendedToReceiveGoodsAndServicesUserConsultingSupport",
  ReceivedInformationAsAResultOfOtherUsersActionsOnTheWebsite = "ReceivedInformationAsAResultOfOtherUsersActionsOnTheWebsite",
  TheCurrentVersionOfTheRegulationIsAPublicDocumentAvailableToAnyInternetUser = "TheCurrentVersionOfTheRegulationIsAPublicDocumentAvailableToAnyInternetUser",
  PersonalDataStorageIsCarriedOutOnlyOnElectronicMediaAndProcessedUsingAutomatedSystemsExceptInCasesWhenNonautomatedProcessingOfPersonalDataIsNecessaryForComplyingWithTheLegalRequirements = "PersonalDataStorageIsCarriedOutOnlyOnElectronicMediaAndProcessedUsingAutomatedSystemsExceptInCasesWhenNonautomatedProcessingOfPersonalDataIsNecessaryForComplyingWithTheLegalRequirements",
  StandardDataAutomaticallyReceivedByTheServerWhenAccessingTheWebsiteAndTheUsersFurtherActionsIPAddressOfTheHostTypeOfTheUsersOperatingSystemWebsitePagesVisitedByTheUser = "StandardDataAutomaticallyReceivedByTheServerWhenAccessingTheWebsiteAndTheUsersFurtherActionsIPAddressOfTheHostTypeOfTheUsersOperatingSystemWebsitePagesVisitedByTheUser",
  ForgotPassword = "ForgotPassword",
  Reset = "Reset",
  YourLoginOrEmail = "YourLoginOrEmail",
  LoginOrEmail = "LoginOrEmail",
  PersonalDataProtectionRegulation = "PersonalDataProtectionRegulation",
  LearningManagementSystem = "LearningManagementSystem",
  EditBill = "EditBill",
  AmountTill = "AmountTill",
  PaymentsRUB = "PaymentsRUB",
  AmountFrom = "AmountFrom",
  AllBills = "AllBills",
  BillsNotFound = "BillsNotFound",
  BillNumber = "BillNumber",
  EnterBillNumber = "EnterBillNumber",
  ReceiptsOnAccount = "ReceiptsOnAccount",
  BalanceRUB = "BalanceRUB",
  RemainingDebt = "RemainingDebt",
  TotalOfAllReceipts = "TotalOfAllReceipts",
  Bill = "Bill",
  PaidInRUB = "PaidInRUB",
  DebtRUB = "DebtRUB",
  EditCompany = "EditCompany",
  NewCompany = "NewCompany",
  InformationAboutEducationalOrganization = "InformationAboutEducationalOrganization",
  DocumentType = "DocumentType",
  NumberOfUsers = "NumberOfUsers",
  AddCertificateOfCompletedWorks = "AddCertificateOfCompletedWorks",
  LearningMaterialsNotSelected = "LearningMaterialsNotSelected",
  AddBill = "AddBill",
  YouCantAddABillWithoutLearningMaterials = "YouCantAddABillWithoutLearningMaterials",
  YouCantAddACertificateOfCompletedWorksWithoutLearningMaterials = "YouCantAddACertificateOfCompletedWorksWithoutLearningMaterials",
  NotAttachments = "NotAttachments",
  ContractorEditing = "ContractorEditing",
  NameTIN = "NameTIN",
  ContractorsNotFound = "ContractorsNotFound",
  NewContractor = "NewContractor",
  CourseEditing = "CourseEditing",
  AdditionalInformation = "AdditionalInformation",
  InformationAboutDocuments = "InformationAboutDocuments",
  CoursesNotFound = "CoursesNotFound",
  YouTeach = "YouTeach",
  YouLearn = "YouLearn",
  NewCourse = "NewCourse",
  NewSCORM = "NewSCORM",
  NewCourseOfTraining = "NewCourseOfTraining",
  FileNotSelected = "FileNotSelected",
  UploadCourse = "UploadCourse",
  Uncompress = "Uncompress",
  FolderTitle = "FolderTitle",
  NewSCORMCourse = "NewSCORMCourse",
  SelectSCORMArchive = "SelectSCORMArchive",
  DoYouReallyWantToCompleteTheTrainingInTheCurrentCourse = "DoYouReallyWantToCompleteTheTrainingInTheCurrentCourse",
  PracticeAssignment = "PracticeAssignment",
  IfTheTestIsntAttachedAStudentInProgressWillNotHaveAccessToTheNextLearningMaterialsUntilHesheOpensTheCurrentMaterial = "IfTheTestIsntAttachedAStudentInProgressWillNotHaveAccessToTheNextLearningMaterialsUntilHesheOpensTheCurrentMaterial",
  IfTheTestIsAttachedToTheLectureAStudentWillNotHaveAccessToTheNextLearningMaterialsUntillHesheTakesTheTestSuccefully = "IfTheTestIsAttachedToTheLectureAStudentWillNotHaveAccessToTheNextLearningMaterialsUntillHesheTakesTheTestSuccefully",
  IfTheTestIsntAttachedAStudentWillNotHaveAccessToTheNextLearningMaterialsUntilHesheOpensTheCurrentMaterial = "IfTheTestIsntAttachedAStudentWillNotHaveAccessToTheNextLearningMaterialsUntilHesheOpensTheCurrentMaterial",
  PracticeAssignmentIsCompleted = "PracticeAssignmentIsCompleted",
  DocumentExpiryDateMonths = "DocumentExpiryDateMonths",
  StartPracticeAssignment = "StartPracticeAssignment",
  AttachTheLectureToTheCourse = "AttachTheLectureToTheCourse",
  NameOfTheFieldOfProfessionalActivity = "NameOfTheFieldOfProfessionalActivity",
  TestSuccessfullyPassed = "TestSuccessfullyPassed",
  AdditionalProfessionalProgram = "AdditionalProfessionalProgram",
  TableOfContents = "TableOfContents",
  IfTheTestIsAttachedToTheLectureAStudentInProgressWillNotHaveAccessToTheNextLearningMaterialsUntillHesheTakesTheTestSuccessfully = "IfTheTestIsAttachedToTheLectureAStudentInProgressWillNotHaveAccessToTheNextLearningMaterialsUntillHesheTakesTheTestSuccessfully",
  NextLecture = "NextLecture",
  Complete = "Complete",
  DoYouReallyWantToCompleteTheCurrentLecture = "DoYouReallyWantToCompleteTheCurrentLecture",
  PreviousLecture = "PreviousLecture",
  DocumentTemplateEditing = "DocumentTemplateEditing",
  NewDocumentTemplate = "NewDocumentTemplate",
  EnterATitleOfTheDocumentTemplate = "EnterATitleOfTheDocumentTemplate",
  OrderOfEnrollment = "OrderOfEnrollment",
  OrderOfCompletion = "OrderOfCompletion",
  GenerateFinalDocumentsForAllUsers = "GenerateFinalDocumentsForAllUsers",
  CreateFinalDocuments = "CreateFinalDocuments",
  EditTrainingProtocol = "EditTrainingProtocol",
  EnterTrainingProtocolNumber = "EnterTrainingProtocolNumber",
  TainingProtocolsNotFound = "TainingProtocolsNotFound",
  NewTrainingProtocol = "NewTrainingProtocol",
  OrderOfEnrollmentEditing = "OrderOfEnrollmentEditing",
  EnterOrderNumber = "EnterOrderNumber",
  OrdersOfEnrollment = "OrdersOfEnrollment",
  NewOrderOfEnrollment = "NewOrderOfEnrollment",
  PleaseTryAgainOrContactTechnicalSupport = "PleaseTryAgainOrContactTechnicalSupport",
  SorrySomethingWentWrong = "SorrySomethingWentWrong",
  OrderOfCompletionEditing = "OrderOfCompletionEditing",
  OrdersOfCompletion = "OrdersOfCompletion",
  NewOrderOfCompletion = "NewOrderOfCompletion",
  EndDate = "EndDate",
  DocumentNumber = "DocumentNumber",
  RecipientsFullName = "RecipientsFullName",
  Expires = "Expires",
  RetrainingIsCarriedOutOnTheBasisOfAEducationalDocument = "RetrainingIsCarriedOutOnTheBasisOfAEducationalDocument",
  ToList = "ToList",
  DuplicateInformation = "DuplicateInformation",
  EditFinalDocument = "EditFinalDocument",
  UnloadingParameters = "UnloadingParameters",
  PageNumber = "PageNumber",
  FinalDocuments = "FinalDocuments",
  HowManyToGenerate = "HowManyToGenerate",
  NumberOfElementsForDownload = "NumberOfElementsForDownload",
  YouDontHaveFinalDocuments = "YouDontHaveFinalDocuments",
  FISFRDOAPE = "FISFRDOAPE",
  IssuedTill = "IssuedTill",
  FISFRDOPT = "FISFRDOPT",
  IssuedFrom = "IssuedFrom",
  SelectStudent = "SelectStudent",
  NewFinalDocument = "NewFinalDocument",
  IMPORTANT = "IMPORTANT",
  SelectACategory = "SelectACategory",
  AlsoBeSureYouHaveAFolder = "AlsoBeSureYouHaveAFolder",
  InCompanysFiles = "InCompanysFiles",
  ImportCourses = "ImportCourses",
  WhenImportingYouShouldSpecifyTheFieldParameters = "WhenImportingYouShouldSpecifyTheFieldParameters",
  EnterTheDomains = "EnterTheDomains",
  EnterADomain = "EnterADomain",
  CopyKey = "CopyKey",
  Token = "Token",
  GenerateKey = "GenerateKey",
  YouCanCopyATokenOnlyNow = "YouCanCopyATokenOnlyNow",
  APIKeyGenerating = "APIKeyGenerating",
  YourAPIKeyIsGenerated = "YourAPIKeyIsGenerated",
  EnterIPOneByOneOrSeveralSeparatedByCommas = "EnterIPOneByOneOrSeveralSeparatedByCommas",
  EnterIP = "EnterIP",
  CreateAWidget = "CreateAWidget",
  Integration = "Integration",
  Widget = "Widget",
  NotificationForTheForm = "NotificationForTheForm",
  NewWidgetOfCompany = "NewWidgetOfCompany",
  EditCompanysWidget = "EditCompanysWidget",
  DownloadTemplate = "DownloadTemplate",
  ImportCompanyUsersFromCsv = "ImportCompanyUsersFromCsv",
  RequirementsToAFile = "RequirementsToAFile",
  Import = "Import",
  TheUserTableShouldConsistOfColumnsInTheFollowingOrder = "TheUserTableShouldConsistOfColumnsInTheFollowingOrder",
  SpecifyTheDelimiter = "SpecifyTheDelimiter",
  TheFileEncodingShouldBeWindows = "TheFileEncodingShouldBeWindows",
  ThePasswordMustBeAtLeastCharactersAndMustContainNumberUppercaseLetterLowercaseLetter = "ThePasswordMustBeAtLeastCharactersAndMustContainNumberUppercaseLetterLowercaseLetter",
  TheFileEncodingShouldBeWindowsCyrillic = "TheFileEncodingShouldBeWindowsCyrillic",
  MustBeFilled = "MustBeFilled",
  EnterSurname = "EnterSurname",
  AddToList = "AddToList",
  UserList = "UserList",
  EnterPatronymic = "EnterPatronymic",
  CourseName = "CourseName",
  AllTrainingStatuses = "AllTrainingStatuses",
  ForExampleIvanov = "ForExampleIvanov",
  Successful = "Successful",
  Unsuccessful = "Unsuccessful",
  GeneralInformation = "GeneralInformation",
  AddToLearningRequest = "AddToLearningRequest",
  RemoveFromLearningRequest = "RemoveFromLearningRequest",
  AddStatus = "AddStatus",
  NewLecture = "NewLecture",
  Lecture = "Lecture",
  TestPassedSuccessfully = "TestPassedSuccessfully",
  ToLectureList = "ToLectureList",
  EditingLearningRequest = "EditingLearningRequest",
  Invitations = "Invitations",
  LearningRequestStatus = "LearningRequestStatus",
  EditLearningRequest = "EditLearningRequest",
  NewLearningRequest = "NewLearningRequest",
  Version = "Version",
  New = "New",
  Old = "Old",
  ConfirmPassword = "ConfirmPassword",
  EditingPracticeAssignment = "EditingPracticeAssignment",
  PracticeAssignmentsNotFound = "PracticeAssignmentsNotFound",
  PendingReview = "PendingReview",
  SentForFinalization = "SentForFinalization",
  CreatePracticeAssignment = "CreatePracticeAssignment",
  PracticeAssignmentResults = "PracticeAssignmentResults",
  NewPracticeAssignment = "NewPracticeAssignment",
  AssignmentToLearningMaterial = "AssignmentToLearningMaterial",
  WriteANewAnswer = "WriteANewAnswer",
  RequiredFinalization = "RequiredFinalization",
  MyPracticeAssignmentResults = "MyPracticeAssignmentResults",
  YouHaventTakenAPracticeAssignmentOfThisCourse = "YouHaventTakenAPracticeAssignmentOfThisCourse",
  EditingRecordedWebinar = "EditingRecordedWebinar",
  NewRecordedWebinar = "NewRecordedWebinar",
  RecordedWebinarNameatLeastCharacters = "RecordedWebinarNameatLeastCharacters",
  UsersWithAccessToARecordedWebinar = "UsersWithAccessToARecordedWebinar",
  CloseAccessForUser = "CloseAccessForUser",
  DocumentName = "DocumentName",
  CreateDocumentType = "CreateDocumentType",
  NewDocumentType = "NewDocumentType",
  TermName = "TermName",
  TermType = "TermType",
  NewFISFRDO = "NewFISFRDO",
  EditingTest = "EditingTest",
  QuestionsUploading = "QuestionsUploading",
  Tests = "Tests",
  EnterTestName = "EnterTestName",
  TestsNotFound = "TestsNotFound",
  NewTest = "NewTest",
  SelectLecture = "SelectLecture",
  SelectStudentInProgress = "SelectStudentInProgress",
  TrainingMaterialWasntSelectedInTheSearchFilterOrStudentsHaventTakenTheTests = "TrainingMaterialWasntSelectedInTheSearchFilterOrStudentsHaventTakenTheTests",
  TestingDate = "TestingDate",
  NotLectureInSelectedCourse = "NotLectureInSelectedCourse",
  TestingFrom = "TestingFrom",
  ResultsOfTests = "ResultsOfTests",
  TestType = "TestType",
  TestingTill = "TestingTill",
  TryAgain = "TryAgain",
  CompleteTheTest = "CompleteTheTest",
  TestToLearningMaterial = "TestToLearningMaterial",
  EditingProfile = "EditingProfile",
  EditProfile = "EditProfile",
  EditingWebinar = "EditingWebinar",
  NewWebinar = "NewWebinar",
  WebinarEndDate = "WebinarEndDate",
  WebinarEndTime = "WebinarEndTime",
  PriceMin = "PriceMin",
  Max = "Max",
  Host = "Host",
  PublicationStatus = "PublicationStatus",
  WebinarStartDate = "WebinarStartDate",
  PriceMax = "PriceMax",
  Min = "Min",
  Hosted = "Hosted",
  WebinarNameatLeastCharacters = "WebinarNameatLeastCharacters",
  Online = "Online",
  Planned = "Planned",
  EnableAWebinarRecording = "EnableAWebinarRecording",
  MaximumNumberOfStudents = "MaximumNumberOfStudents",
  SelectWebinarPlatform = "SelectWebinarPlatform",
  UsersWithAccessToWebinar = "UsersWithAccessToWebinar",
  LinkToTheSource = "LinkToTheSource",
  TurnOffPublicChatForUsers = "TurnOffPublicChatForUsers",
  Own = "Own",
  StartTime = "StartTime",
  DisableAMicrophoneUsingForUsers = "DisableAMicrophoneUsingForUsers",
  Thirdparty = "Thirdparty",
  EndTime = "EndTime",
  UserNotFound = "UserNotFound",
  DisableAWebcamUsingForUsers = "DisableAWebcamUsingForUsers",
  PasteTheLinkToTheSourceWhereTheWebinarWillBeHosted = "PasteTheLinkToTheSourceWhereTheWebinarWillBeHosted",
  Completion = "Completion",
  RecordsWillBeDeletedAfterDays = "RecordsWillBeDeletedAfterDays",
  Platform = "Platform",
  TheRecordIsBeingPrepared = "TheRecordIsBeingPrepared",
  EditWebinar = "EditWebinar",
  WebcamRecording = "WebcamRecording",
  ScreenRecording = "ScreenRecording",
  Start = "Start",
  CheckForRecordedWebinars = "CheckForRecordedWebinars",
  RecordedWebinarsNotFound = "RecordedWebinarsNotFound",
  StudentsNumber = "StudentsNumber",
  WatchWebinar = "WatchWebinar",
  FirstNameAddressEmailAndorPhoneAreProvidedByTheUserForFeedbackAndForStandardWorkOnTheWebsiteIsNotRequired = "FirstNameAddressEmailAndorPhoneAreProvidedByTheUserForFeedbackAndForStandardWorkOnTheWebsiteIsNotRequired",
  Export = "Export",
  Contracts = "Contracts",
  Yes = "Yes",
  No = "No",
  Employees = "Employees",
  Records = "Records",
  Record = "Record",
  CreateRecord = "CreateRecord",
  FullNameUser = "FullNameUser",
  FreeDiskSpace = "FreeDiskSpace",
  Hide = "Hide",
  Show = "Show",
  UserName = "UserName",
  Source = "Source",
  PasswordsDoNotMatch = "PasswordsDoNotMatch",
  Error = "Error",
  TheInformationHasBeenSuccessfullyChanged = "TheInformationHasBeenSuccessfullyChanged",
  UnknownError = "Unknown error",
  DoNotAttachTheTest = "DoNotAttachTheTest",
  ChangesHaveBeenSuccessfullySaved = "ChangesHaveBeenSuccessfullySaved",
  AddQuestionsToTheTest = "AddQuestionsToTheTest",
  TheQuestionCannotBeEmpty = "TheQuestionCannotBeEmpty",
  TheAnswerChoiceCannotBeEmpty = "TheAnswerChoiceCannotBeEmpty",
  AtLeastOneAnswerMustBeCorrect = "AtLeastOneAnswerMustBeCorrect",
  Learning = "Learning",
  Pause = "Pause",
  Success = "Success",
  Fail = "Fail",
  Canceled = "Canceled",
  UseTheKeyboardArrowsToSelectDate = "UseTheKeyboardArrowsToSelectDate",
  UserHasAlreadyCompletedTrainingIfYouNeedToRetrain = "UserHasAlreadyCompletedTrainingIfYouNeedToRetrain",
  TestFailed = "TestFailed",
  TheNumberOfCreatedTestQuestionsCannotBeLessThanTheActualNumberOfQuestionsInTheTest = "TheNumberOfCreatedTestQuestionsCannotBeLessThanTheActualNumberOfQuestionsInTheTest",
  ThisIsTheFirstParagraphOfTheQuestion = "ThisIsTheFirstParagraphOfTheQuestion",
  SecondParagraphOfTheQuestion = "SecondParagraphOfTheQuestion",
  AnswerDesc = "AnswerDesc",
  CorrectAnswerCommentOnTheAnswer = "CorrectAnswerCommentOnTheAnswer",
  PushkinWasBornIn = "PushkinWasBornIn",
  YesterdayDesc = "YesterdayDesc",
  Reply = "Reply",
  ChooseAtLeastOneAnswer = "ChooseAtLeastOneAnswer",
  TimeExpired = "TimeExpired",
  NotLimited = "NotLimited",
  AQuestionCannotContainLessThanTwoAnswers = "AQuestionCannotContainLessThanTwoAnswers",
  QuestionAdded = "QuestionAdded",
  SortingHasBeenChanged = "SortingHasBeenChanged",
  NotAttached = "NotAttached",
  AccessDenied = "AccessDenied",
  AccessGranted = "AccessGranted",
  NotComplete = "NotComplete",
  CompletedUnsuccessfully = "CompletedUnsuccessfully",
  Access = "Access",
  FirstName = "FirstName",
  NoDateSpecified = "NoDateSpecified",
  PendingVerification = "PendingVerification",
  NotFilled = "NotFilled",
  AlreadyCreated = "AlreadyCreated",
  NewContract = "NewContract",
  TheTrainingCanBeCompletedByTheResponsibleTeacher = "TheTrainingCanBeCompletedByTheResponsibleTeacher",
  SomeRequiredFieldsAreNotFilledIn = "SomeRequiredFieldsAreNotFilledIn",
  SearchByEmail = "SearchByEmail",
  SuccessfullyDeleted = "SuccessfullyDeleted",
  ChooseAtLeastOneCourse = "ChooseAtLeastOneCourse",
  ASlideCannotBeEmpty = "ASlideCannotBeEmpty",
  Untitled = "Untitled",
  Indefinitely = "Indefinitely",
  ProfessionalEducation = "ProfessionalEducation",
  AdditionalProfessionalEducation = "AdditionalProfessionalEducation",
  InvitationsHaveBeenSuccessfullySent = "InvitationsHaveBeenSuccessfullySent",
  Activated = "Activated",
  NotActivated = "NotActivated",
  ShowMore = "ShowMore",
  ThankYouYourLearningRequestWasSuccessfullyCreated = "ThankYouYourLearningRequestWasSuccessfullyCreated",
  IfAnythingGoesWrongOrYouHaveQuestions = "IfAnythingGoesWrongOrYouHaveQuestions",
  CodeCopiedSuccessfully = "CodeCopiedSuccessfully",
  InsertTheCodeBelowBeforeTheClosingTag = "InsertTheCodeBelowBeforeTheClosingTag",
  onYourSite = "onYourSite",
  MostPopular = "MostPopular",
  NoTest = "NoTest",
  NoPractice = "NoPractice",
  TheTestHasNotStarted = "TheTestHasNotStarted",
  FromTheArchive = "FromTheArchive",
  NextMonth = "NextMonth",
  PreviousMonth = "PreviousMonth",
  NextYear = "NextYear",
  PreviousYear = "PreviousYear",
  Day = "Day",
  IncorrectEmailFormat = "IncorrectEmailFormat",
  AllValuesOfTheFieldsAtTheMomentWillBeSaved = "AllValuesOfTheFieldsAtTheMomentWillBeSaved",
  DoYouReallyWantToRemoveTheDocumentFromTheArchive = "DoYouReallyWantToRemoveTheDocumentFromTheArchive",
  DoYouReallyWantToMoveTheDocumentToTheArchive = "DoYouReallyWantToMoveTheDocumentToTheArchive",
  MinimumNumberOfCharactersEntered = "MinimumNumberOfCharactersEntered",
  ThePasswordMustConsistOfNumbersAndUpperAndLowerCaseLatinLetters = "ThePasswordMustConsistOfNumbersAndUpperAndLowerCaseLatinLetters",
  ThisFieldIsRequired = "ThisFieldIsRequired",
  UnableToRetrieveUserInformation = "UnableToRetrieveUserInformation",
  YouAnsweredCorrectlyTo = "YouAnsweredCorrectlyTo",
  outOf = "outOf",
  questionsOf = "questionsOf",
  YouMustSelectAtLeastOneOption = "YouMustSelectAtLeastOneOption",
  LectureTest = "LectureTest",
  CourseTest = "CourseTest",
  LogIn = "LogIn",
  AttachAStudentToTheUser = "AttachAStudentToTheUser",
  UserPasswordSettings = "UserPasswordSettings",
  BasicInformation = "BasicInformation",
  StructureAndManagementBodies = "StructureAndManagementBodies",
  EducationalStandards = "EducationalStandards",
  ManagementPedagogicalStaff = "ManagementPedagogicalStaff",
  MaterialAndTechnicalSupportAndEquipmentOfTheEducationalProcess = "MaterialAndTechnicalSupportAndEquipmentOfTheEducationalProcess",
  ScholarshipsAndOtherTypesOfMaterialSupport = "ScholarshipsAndOtherTypesOfMaterialSupport",
  FinancialAndEconomicActivities = "FinancialAndEconomicActivities",
  VacantPlacesForAdmission = "VacantPlacesForAdmission",
  AccessibleEnvironment = "AccessibleEnvironment",
  InternationalCooperation = "InternationalCooperation",
  PaidEducationalServices = "PaidEducationalServices",
  Citizenship = "Citizenship",
  Passport = "Passport",
  NewStudent = "NewStudent",
  YouCannotCreateInvoiceAmountGreaterThanContractAmount = "YouCannotCreateInvoiceAmountGreaterThanContractAmount",
  TheDiskVolumeCannotBeLessThanTheOccupiedSpace = "TheDiskVolumeCannotBeLessThanTheOccupiedSpace",
  EnterTheAmount = "EnterTheAmount",
  OneOrMoreFieldsAreEmpty = "OneOrMoreFieldsAreEmpty",
  SelectStudents = "SelectStudents",
  AtLeastOneUserMustBeSelected = "AtLeastOneUserMustBeSelected",
  GeneratePDF = "GeneratePDF",
  TheLinkToChangeYourPasswordWasSentToTheEmail = "TheLinkToChangeYourPasswordWasSentToTheEmail",
  ImportedUsers = "ImportedUsers",
  CreateStudents = "CreateStudents",
  CreateLearningRequest = "CreateLearningRequest",
  Lesson = "Lesson",
  DocumentNumbering = "DocumentNumbering",
  CreatingANumbering = "CreatingANumbering",
  DocumentTemplates = "DocumentTemplates",
  TrainingProtocols = "TrainingProtocols",
  UploadCSVFileWithListOfYourUsersToTheFileManager = "UploadCSVFileWithListOfYourUsersToTheFileManager",
  UploadCSVFileWithListOfYourContractorsToTheFileManager = "UploadCSVFileWithListOfYourContractorsToTheFileManager",
  IfTheUsernameAndPasswordFieldsAreNotFilled = "IfTheUsernameAndPasswordFieldsAreNotFilled",
  FastDocumentCreation = "FastDocumentCreation",
  MyPracticalAssignments = "MyPracticalAssignments",
  MyTestResults = "MyTestResults",
  ApplicationProfiles = "ApplicationProfiles",
  WaitingForPayment = "WaitingForPayment",
  TrainingInProgress = "TrainingInProgress",
  CancelAll = "CancelAll",
  TheDateAreAsDayMonthYear = "TheDateAreAsDayMonthYear",
  TheGenderIsIndicatedByNumbers = "TheGenderIsIndicatedByNumbers",
  UserSuccessfullyDisconnectedFromTheVideo = "UserSuccessfullyDisconnectedFromTheVideo",
  UserSuccessfullyAddedToVideo = "UserSuccessfullyAddedToVideo",
  RegistrationLinksWereSentToEmail = "RegistrationLinksWereSentToEmail",
  TheUserIsNotAnActiveStudentInTheCourse = "TheUserIsNotAnActiveStudentInTheCourse",
  TheChangesYouMadeMayNotBeSaved = "TheChangesYouMadeMayNotBeSaved",
  MaximumNumberOfUsersWithAccessToTheWebinar = "MaximumNumberOfUsersWithAccessToTheWebinar",
  PleaseSpecifyTheMaximumNumberOfUsersWhoHaveAccessToTheWebinar = "PleaseSpecifyTheMaximumNumberOfUsersWhoHaveAccessToTheWebinar",
  YouCanEnterTheWebinarRoomOnlyMinutesBeforeTheStart = "YouCanEnterTheWebinarRoomOnlyMinutesBeforeTheStart",
  EntriesAreDeletedAfterDays = "EntriesAreDeletedAfterDays",
  TheFormedFieldIsRequired = "TheFormedFieldIsRequired",
  SelectAFile = "SelectAFile",
  IncorrectDocumentFormatOnlyDocxIsAllowed = "IncorrectDocumentFormatOnlyDocxIsAllowed",
  CompletedAndPassed = "CompletedAndPassed",
  Waived = "Waived",
  Abandoned = "Abandoned",
  Satisfied = "Satisfied",
  Paste = "Paste",
  ImportContractorsFromCsv = "ImportContractorsFromCsv",
  ImportContractors = "ImportContractors",
  ImportOfContractors = "ImportOfContractors",
  TheContractorsTableShouldConsistOfColumnsInTheFollowingOrder = "TheContractorsTableShouldConsistOfColumnsInTheFollowingOrder",
  AskAllQuestionsInPracticeTest = "AskAllQuestionsInPracticeTest",
  DoNotLimitTheTimeOfPracticeTest = "DoNotLimitTheTimeOfPracticeTest",
  CopiedQuestions = "CopiedQuestions",
  LoginLink = "LoginLink",
  AccessCopied = "AccessCopied",
  ShowAnswersImmediatelyInPracticeTest = "ShowAnswersImmediatelyInPracticeTest",
  docGenerate = "docGenerate",
  YouCanOnlyUseScvFile = "YouCanOnlyUseScvFile",
  RussianLanguage = "RussianLanguage",
  EnglishLanguage = "EnglishLanguage",
  Language = "Language",
  WebinarNotStarted = "WebinarNotStarted",
  Notice = "Notice",
  Ended = "Ended",
  Month = "Month",
  Year = "Year",
  FullYear = "FullYear",
  BindToDate = "BindToDate",
  UpdateFrequency = "UpdateFrequency",
  ThisAnswerIsCorrectYouDidntChooseTheCorrectAnswer = "ThisAnswerIsCorrectYouDidntChooseTheCorrectAnswer",
  DomainMail = "DomainMail",
  TrainingGroups = "TrainingGroups",
  TrainingGroup = "TrainingGroup",
  TheStartDateOfTrainingFrom = "TheStartDateOfTrainingFrom",
  TheStartDateOfTrainingOn = "TheStartDateOfTrainingOn",
  NewGroup = "NewGroup",
  NoData = "NoData",
  Loading = "Loading",
  Home = "Home",
  GenerateAccesses = "GenerateAccesses",
  Configuration = "Configuration",
  EmployeeDeleted = "EmployeeDeleted",
  DisabledCompany = "DisabledCompany",
  ChooseStudents = "ChooseStudents",
  TokensList = "TokensList",
  CopyToTheCurrentFolder = "CopyToTheCurrentFolder",
  MoveToTheCurrentFolder = "MoveToTheCurrentFolder",
  DeleteSelectedFiles = "DeleteSelectedFiles",
  FormedContracts = "FormedContracts",
  FormedBills = "FormedBills",
  FormedActs = "FormedActs",
  FormedOrdersOfEnrollments = "FormedOrdersOfEnrollment",
  FormedOrdersOfCompletions = "FormedOrdersOfCompletion",
  FormedTrainingProtocols = "FormedTrainingProtocols",
  FormedFinalDocuments = "FormedFinalDocuments",
  NumberOfApplicationsWithCurrentProfile = "NumberOfApplicationsWithCurrentProfile",
  Indefinite = "Indefinite",
  AdditionalFeatures = "AdditionalFeatures",
  PageNotFound = "PageNotFound",
  PageAccessDenied = "PageAccessDenied",
  NotDefined = "NotDefined",
  Aborted = "Aborted",
  RegistrationExistMessage = "RegistrationExistMessage",
  Update = "Update",
  ShortNameFisFrdo = "ShortNameFisFrdo",
  AvailableSpacesForStudents = "AvailableSpacesForStudents",
  DirectorPositionGenitive = "DirectorPositionGenitive",
  DirectorNameInitials = "DirectorNameInitials",
  LastLogin = "LastLogin",
  RequiredData = "RequiredData",
  NewAgent = "NewAgent",
  Agents = "Agents",
  Agent = "Agent",
  IsPercent = "IsPercent",
  CreatePaymentTerms = "CreatePaymentTerms",
  Value = "Value",
  AgentReports = "AgentReports",
  PaidToTheAgent = "PaidToTheAgent",
  PaidFrom = "PaidFrom",
  PaidTill = "PaidTill",
  TermsOfPaymentToTheAgent = "TermsOfPaymentToTheAgent",
  Received = "Received",
  Agency = "Agency",
  ConditionList = "ConditionList",
  LicenseList = "LicenseList",
  Calculate = "Calculate",
  AmountOfWorkingHoursPerDay = "AmountOfWorkingHoursPerDay",
  Weekends = "Weekends",
  Monday = "Monday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
  Thursday = "Thursday",
  Friday = "Friday",
  Saturday = "Saturday",
  Sunday = "Sunday",
  EditContractor = "EditContractor",
  Image = "Image",
  PracticeAssignmentPlural = "PracticeAssignmentPlural",
  LockSettingsDisableCamera = "LockSettingsDisableCamera",
  LockSettingsDisableMicrophone = "LockSettingsDisableMicrophone",
  LockSettingsDisablePublicChat = "LockSettingsDisablePublicChat",
  ChangeView = "ChangeView",
  ContractorCreate = "ContractorCreate",
  SuccessfullyCompleteTheProgressOfTheTraining = "SuccessfullyCompleteTheProgressOfTheTraining",
  InsertTable = "InsertTable",
  AddColumnBefore = "AddColumnBefore",
  AddColumnAfter = "AddColumnAfter",
  DeleteColumn = "DeleteColumn",
  AddRowBefore = "AddRowBefore",
  AddRowAfter = "AddRowAfter",
  DeleteRow = "DeleteRow",
  DeleteTable = "DeleteTable",
  MergeCells = "MergeCells",
  SplitCell = "SplitCell",
  ToggleHeaderColumn = "ToggleHeaderColumn",
  ToggleHeaderRow = "ToggleHeaderRow",
  ToggleHeaderCell = "ToggleHeaderCell",
  MergeOrSplit = "MergeOrSplit",
  SetCellAttribute = "SetCellAttribute",
  FixTables = "FixTables",
  GoToNextCell = "GoToNextCell",
  GoToPreviousCell = "GoToPreviousCell",
  ClearFinalDocumentExport = "ClearFinalDocumentExport",
  Instructions = "Instructions",
  Accounting = "Accounting",
  InProgress = "InProgress",
  CloseAccessToTrainingMaterials = "CloseAccessToTrainingMaterials",
  RequestAmount = "RequestAmount",
  ListOfLicenses = "ListOfLicenses",
  StudentDocuments = "StudentDocuments",
  YouCanOnlyAddStudentsToAGroupWithTheStatusLearning = "YouCanOnlyAddStudentsToAGroupWithTheStatusLearning",
  Send = "Send",
  Chats = "Chats",
  NoMessages = "NoMessages",
  ToMyAccount = "ToMyAccount",
  ToOtherAccounts = "ToOtherAccounts",
  UserDoesNotHaveAccessToYourAccount = "UserDoesNotHaveAccessToYourAccount",
  TheUserHasAccessToYourAccount = "TheUserHasAccessToYourAccount",
  UserAccesses = "UserAccesses",
  MyAccesses = "MyAccesses",
  Provide = "Provide",
  YouHaveAccessToTheUser = "YouHaveAccessToTheUser",
  YouDoNotHaveAccessToTheUser = "YouDoNotHaveAccessToTheUser",
  Request = "Request",
  YouAreUnderADifferentAccountAndYouWillAutomaticallyReturnToYourAccountThrough = "YouAreUnderADifferentAccountAndYouWillAutomaticallyReturnToYourAccountThrough",
  Read = "Read",
  NotRead = "NotRead",
  Header = "Header",
  Body = "Body",
  Footer = "Footer",
  NewDeal = "NewDeal",
  PassingTheTestSuccessfully = "PassingTheTestSuccessfully",
  EnrollmentInTheCourse = "EnrollmentInTheCourse",
  BelowYouCanChangeTheMessagesSentToUsersOnTheSiteOrByEmailClearTheFieldsIfYouWantToLeaveTheDefaultNotificationText = "BelowYouCanChangeTheMessagesSentToUsersOnTheSiteOrByEmailClearTheFieldsIfYouWantToLeaveTheDefaultNotificationText",
  AvailableTokens = "AvailableTokens",
  MarkAsRead = "MarkAsRead",
  NoNewNotifications = "NoNewNotifications",
  ViewAllNotifications = "ViewAllNotifications",
  Notifications = "Notifications",
  IntoTheSystem = "IntoTheSystem",
  EmailNotifications = "EmailNotifications",
  NotificationTemplates = "NotificationTemplates",
  Agreed = "Agreed",
  DidNotAgree = "DidNotAgree",
  YouAreGrantedAccessToTheAccount = "YouAreGrantedAccessToTheAccount",
  WantsAccessToYourAccount = "WantsAccessToYourAccount",
  SystemSupport = "SystemSupport",
  CompanySupport = "CompanySupport",
  WriteMessage = "WriteMessage",
  ChooseStaffMemberToAnswerGeneralStudentQuestions = "ChooseStaffMemberToAnswerGeneralStudentQuestions",
  AccessToTheAccountGasBeenRequestedPleaseWait = "AccessToTheAccountGasBeenRequestedPleaseWait",
  TheFileHasBeenImportedYouCanSeeTheNumbersInTheListOfStudentsInTheTrainingProtocol = "TheFileHasBeenImportedYouCanSeeTheNumbersInTheListOfStudentsInTheTrainingProtocol",
  ImportSummary = "ImportSummary",
  EmailFullNameSnilsOrPhone = "EmailFullNameSnilsOrPhone",
  ExistStudentMessage = "ExistStudentMessage",
  RecentFiles = "RecentFiles",
  OpenFullScreen = "OpenFullScreen",
  TryTheNewInterfaceLabel = "TryTheNewInterfaceLabel",
  TryTheNewInterfaceText = "TryTheNewInterfaceText",
  ChangeApplicationVersion = "ChangeApplicationVersion",
  CreateAtLeastOneFinalDocument = "CreateAtLeastOneFinalDocument",
  RecordWebinar = "RecordWebinar",
  UpdateJournal = "UpdateJournal",
  Progress = "Progress",
  LessonBlock = "LessonBlock",
  ShowCorrectAnswers = "ShowCorrectAnswers",
  NDS = "NDS",
  WithOutNDS = "WithOutNDS",
  AskQuestion = "AskQuestion",
  FreeNavigationCourseLabelIcon = "FreeNavigationCourseLabelIcon",
  YouHaveNotBeenGrantedAccessToTheLessonStudy = "YouHaveNotBeenGrantedAccessToTheLessonStudy",
  FreeMovementIsNotAllowedStudyThePreviousLessons = "FreeMovementIsNotAllowedStudyThePreviousLessons",
  LaborProtectionWorker = "LaborProtectionWorker",
  LaborProtection = "LaborProtection",
  ShowDetails = "ShowDetails",
  Errors = "Errors",
  ErrorsWereFoundInTheFollowingLinesFixThemAndStartImportingAgain = "ErrorsWereFoundInTheFollowingLinesFixThemAndStartImportingAgain",
  Line = "Line",
  OrdersAlreadyCreated = "OrdersAlreadyCreated",
  AddToTheOrder = "AddToTheOrder",
  YourCurrentVersion = "YourCurrentVersion",
  ScopeOfActivity = "ScopeOfActivity",
  CountOfVariantsAndQuestions = "CountOfVariantsAndQuestions",
  CountOfVariants = "CountOfVariants",
  CountOfQuestions = "CountOfQuestions",
  Variant = "Variant",
  DifficultyLevel = "DifficultyLevel",
  Easy = "Easy",
  Medium = "Medium",
  Hard = "Hard",
  AnyAnswerIsCorrect = "AnyAnswerIsCorrect",
  SettingPointsForPassing = "SettingPointsForPassing",
  MinimumNumberOfCorrectAnswers = "MinimumNumberOfCorrectAnswers",
  InRandomOrder = "InRandomOrder",
  ByComplexity = "ByComplexity",
  ByVariants = "ByVariants",
  EditContent = "EditContent",
  YouCanPractiseTakingTheTestByClickingOnThePracticeTest = "YouCanPractiseTakingTheTestByClickingOnThePracticeTest",
  ShowCorrectAnswersAfterPassing = "ShowCorrectAnswersAfterPassing",
  TestFormVariantsInfo = "TestFormVariantsInfo",
  SortVariants = "SortVariants",
  Alignment = "Alignment",
  Small = "Small",
  Large = "Large",
  Fullscreen = "Fullscreen",
  Left = "Left",
  Right = "Right",
  Center = "Center",
  Regular = "Regular",
  ChooseWhatHappensWhenTheRequestMovesToThisStatus = "ChooseWhatHappensWhenTheRequestMovesToThisStatus",
  SelectTheStatusesToWhichTheApplicationCanBeTransferredFromThisStatus = "SelectTheStatusesToWhichTheApplicationCanBeTransferredFromThisStatus",
  Schedule = "Schedule",
  Desk = "Desk",
  WebCamera = "WebCamera",
  FullRecord = "FullRecord",
  NoRecordedWebinarsFound = "NoRecordedWebinarsFound",
  CheckWebinarRecords = "CheckWebinarRecords",
  NewSlide = "NewSlide",
  NewVideo = "NewVideo",
  Imports = "Imports",
  SelectACourseAndContractor = "SelectACourseAndContractor",
  TheFoundStudentsHaveSeveralContractorsPleaseSelectTheOneYouNeedAndContinueExporting = "TheFoundStudentsHaveSeveralContractorsPleaseSelectTheOneYouNeedAndContinueExporting",
  Minute = "Minute",
  ToEvaluateTheStudentPracticeYouMustGoToTheDesiredSession = "ToEvaluateTheStudentPracticeYouMustGoToTheDesiredSession",
  AdvancedEditor = "AdvancedEditor",
  Positions = "Positions",
  AgentPaymentAt = "AgentPaymentAt",
  SuccessfullyRegistered = "SuccessfullyRegistered",
  StatusOfYourStudy = "StatusOfYourStudy",
  StudyOfMaterials = "StudyOfMaterials",
  SpecifyTheSource = "SpecifyTheSource",
  SelectStatusGroup = "SelectStatusGroup",
  TheStudentHasNotYetBeenGrantedAccessTraining = "TheStudentHasNotYetBeenGrantedAccessTraining",
  CompanyTimeSet = "CompanyTimeSet",
  ToTheTableOfContents = "ToTheTableOfContents",
  NoServerConnectionTryLater = "NoServerConnectionTryLater",
  NotPublished = "NotPublished",
  AccountAsLogin = "AccountAsLogin",
  GrantAccessByEmail = "GrantAccessByEmail",
  ExpirationDate = "ExpirationDate",
  ChangesYouMadeMayNotBeSaved = "ChangesYouMadeMayNotBeSaved",
  Director = "Director",
  Exit = "Exit",
  GenerateXML = "GenerateXML",
  FISFRDOunloaded = "FISFRDOunloaded",
  FISFRDOunloadedFrom = "FISFRDOunloadedFrom",
  FileTypeFISFRDO = "FileTypeFISFRDO",
  HomePage = "HomePage",
  ChangeUserName = "ChangeUserName",
  MyTraining = "MyTraining",
}
